export default __webpack_public_path__ + "static/img2-f9322139bf094077d060198e9283134c.jpg";